import { useContext } from "react"
import { useMutation } from "react-apollo"

import { SessionContext } from "contexts/session"

import { queryOptions } from "utils/helper"

import DELETE_USER from "../../graphql/UserManagement/mutations/deleteUser"

const useDeleteUserMutation = options => {
  const { user } = useContext(SessionContext)

  return useMutation(DELETE_USER, {
    ...queryOptions(user, true),
    ...options,
    refetchQueries: ['FindOneUser'],
  });
}

export default useDeleteUserMutation
